export const THREE_CARD_POKER_PLAYER_DECISION = '3cp_player_decision';
export const THREE_CARD_POKER_CARDS_DISPLAY_TOGGLE = '3cp_cards_display_toggle';
